import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import CustomSelect from '../home/collections/CustomSelect';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import {
  getFontStyle,
  getFontWeight,
  getFontsOptions,
  initialValues,
  loadFontStyle,
  transformData,
} from './utils';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import voca from 'voca';
import Swal from 'sweetalert2';

export class GoogleFonts extends Component {
  static propTypes = {
    onBoarding: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    conditions: [],
    selectedFontFamily: '',
    disableAddButton: true,
  };

  componentDidMount() {
    const { actions, match } = this.props;
    const { version, projectId } = match.params;
    actions.getGoogleFonts();
    actions.getCustomFonts({ version, projectId });
  }

  addCustomFonts = () => {
    const { googleFonts } = this.props.onBoarding;
    const selectedFont = googleFonts.find((f) => f.family === this.state.selectedFontFamily);
    this.setState({
      conditions: [
        {
          id: 1,
          value: '',
          family: this.state.selectedFontFamily,
          files: selectedFont ? selectedFont.files : {},
        },
      ],
      selectedFontFamily: this.state.selectedFontFamily,
      disableAddButton: true,
    });
  };

  handleChange = (name, value) => {
    const selectedFontFamily = value ? value.label : '';

    this.setState(
      (prevState) => ({
        selectedFontFamily,
        disableAddButton:
          !selectedFontFamily ||
          prevState.conditions.some((condition) => condition.family === selectedFontFamily),
      }),
      () => this.addCustomFonts(),
    );
  };

  handleRemoveConditionFontsCard = (conditionId) => {
    this.setState((prevState) => {
      const updatedConditions = prevState.conditions.filter(
        (condition) => condition.id !== conditionId,
      );

      const isButtonDisabled =
        !this.state.selectedFontFamily ||
        updatedConditions.some((condition) => condition.family === this.state.selectedFontFamily);

      return {
        conditions: updatedConditions,
        disableAddButton: !this.state.selectedFontFamily || isButtonDisabled,
      };
    });
  };

  handleSaveCustomFont = async (conditionId) => {
    const { actions, match } = this.props;
    const { version, projectId } = match.params;
    const condition = this.state.conditions.find((c) => c.id === conditionId);
    const { files } = condition;
    const selectedFiles = Object.keys(files).map((key) => ({
      [key]: files[key],
    }));
    const data = { ...condition, type: 'GOOGLE_FONT', selectedFiles };
    const customFontsData = transformData(data);

    try {
      await actions.addCustomFontsInProject({ version, projectId, customFontsData });
    } catch (error) {
      console.error('Failed to add custom fonts:', error);
    } finally {
      // this.handleRemoveConditionFontsCard(conditionId);
    }
  };

  handleFontDelete = async (fontUuid) => {
    const { actions, match } = this.props;
    const { version, projectId } = match.params;
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await actions.deleteCustomFont({ version, projectId, fontUuid });
          Swal.fire('Deleted!', 'Your font has been deleted.', 'success');
        } catch (error) {
          Swal.fire('Error!', 'There was an error deleting the font.', 'error');
        }
      }
    });
  };

  createConditionFontsCard = (setFieldValue, setFieldTouched) => {
    const { conditions } = this.state;
    const mostRecentCondition = conditions[conditions.length - 1];
    if (!mostRecentCondition)
      return (
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
          <div className="card">
            <div className="card-header card-header-text" data-background-color="drapcode-violet">
              <h6 className="card-title pb-0 mb-0 text-capitalise">Font - Preview </h6>
            </div>

            <div className="card-content">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Variant</th>
                      <th>Preview</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="3" style={{ textAlign: 'center' }}>
                        <h4>No fonts selected.</h4>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      );
    const fontStyle = loadFontStyle(mostRecentCondition.family);

    return (
      mostRecentCondition.family && (
        <div
          className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode"
          key={mostRecentCondition.id}
        >
          <div className="card">
            <div className="card-header card-header-text" data-background-color="drapcode-violet">
              <h6 className="card-title pb-0 mb-0 text-capitalise">
                {mostRecentCondition.family} - Preview{' '}
              </h6>
            </div>

            <div className="card-content">
              <div
                className="table-responsive show_scrollbar"
                style={{ height: '150px', overflow: 'auto' }}
              >
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Variant</th>
                      <th>Preview</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(mostRecentCondition.files).map((variant, index) => (
                      <tr key={variant}>
                        <td>{index + 1}</td>
                        <td>{voca.titleCase(variant)}</td>
                        <td>
                          <span
                            style={{
                              fontFamily: mostRecentCondition.family,
                              fontWeight: getFontWeight(variant),
                              fontStyle: getFontStyle(variant),
                            }}
                          >
                            A quick brown fox jumps over the lazy dog.
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )
    );
  };

  showFontsDetail = (font) => {
    const fontStyle = loadFontStyle(font.family);
    const variantsList = Object.keys(font.variants);
    return (
      <AccordionItem key={font.family}>
        <AccordionItemHeading>
          <AccordionItemButton>
            <strong>
              <span style={fontStyle}>{font.family}</span>
            </strong>
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <div
            className="table-responsive show_scrollbar"
            style={{ height: '150px', overflow: 'auto' }}
          >
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Variant</th>
                  <th>Preview</th>
                </tr>
              </thead>
              <tbody>
                {variantsList.map((variant, index) => (
                  <tr key={variant}>
                    <td>{index + 1}</td>
                    <td>{voca.titleCase(variant)}</td>
                    <td>
                      <span
                        style={{
                          fontFamily: font.family,
                          fontWeight: getFontWeight(variant),
                          fontStyle: getFontStyle(variant),
                        }}
                      >
                        A quick brown fox jumps over the lazy dog.
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="text-right mt-3">
            <button
              onClick={() => this.handleFontDelete(font.uuid)}
              type="button"
              className="btn btn-sm btn-theme-delete"
              title="Delete Font"
            >
              <i className="wb webconnect-trash-regular"></i>&nbsp;Delete
            </button>
          </div>
        </AccordionItemPanel>
      </AccordionItem>
    );
  };

  render() {
    const { onBoarding, match } = this.props;
    const { googleFonts, customFontsList } = onBoarding;
    const { version, projectId } = match.params;
    const googlefontsOptions = getFontsOptions(googleFonts);
    console.log("googlefontOptions",googlefontsOptions);
    const isContinue = customFontsList.length > 0;
    return (
      <CommonPageComponent>
        <ParentContentCard title={'Choose Custom Fonts'} icon={'customFonts'}>
          <div className="row p-1 mb-3">
            <div className="col-12">
              <div className="container-fluid mb-3">
                <h5 style={{ textTransform: 'none' }}>
                  You can apply selected fonts across application, enhancing the Ul by ensuring
                  consistent typography throughout all components.
                </h5>
              </div>

              <Formik initialValues={initialValues} enableReinitialize>
                {({ setFieldValue, setFieldTouched, values }) => {
                  return (
                    <Form className="form-horizontal">
                      <div className="row mx-auto"></div>
                      <div className="row mx-auto mt-4 mb-4">
                        <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                          <FormFieldWithLabel
                            cta={false}
                            label="Select Fonts"
                            icon="select"
                            infoIcon={true}
                            infoDescription={`Use this dropdown to choose a font for your project.`}
                          >
                            <CustomSelect
                              name="selectFont"
                              isMulti={false}
                              value={values.selectFont}
                              options={googlefontsOptions}
                              onChange={setFieldValue}
                              onChangeValue={this.handleChange}
                              onBlur={() => setFieldTouched('selectFont', true)}
                              placeholder="Fonts"
                              isCustomFont={true}
                            />
                            <ErrorMessage name="selectFont">
                              {(msg) => <p className="text-error">{msg}</p>}
                            </ErrorMessage>
                          </FormFieldWithLabel>
                          {this.state.conditions.length > 0 && (
                            <div className="text-right mt-4 col-11">
                              <button
                                onClick={() =>
                                  this.handleRemoveConditionFontsCard(
                                    this.state.conditions[this.state.conditions.length - 1].id,
                                  )
                                }
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                title="Delete Font"
                              >
                                <i className="wb webconnect-times"></i>&nbsp;Cancel
                              </button>
                              &nbsp;
                              <button
                                onClick={() =>
                                  this.handleSaveCustomFont(
                                    this.state.conditions[this.state.conditions.length - 1].id,
                                  )
                                }
                                type="button"
                                className="btn btn-sm btn-theme-submit"
                                title="Save Font"
                              >
                                <i className="wb webconnect-save-regular"></i>&nbsp;Add
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                          {this.createConditionFontsCard(setFieldValue, setFieldTouched)}
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </ParentContentCard>
        <ParentContentCard icon="list" title={'Installed Fonts'}>
          <div className="row modal-scroll">
            <div className="col-12">
              {customFontsList.length > 0 ? (
                <Accordion allowZeroExpanded>
                  {customFontsList && customFontsList.map((font) => this.showFontsDetail(font))}
                </Accordion>
              ) : (
                <h4 style={{ textAlign: 'center', marginTop: '20px' }}>No fonts installed.</h4>
              )}
            </div>
          </div>
        </ParentContentCard>
        <div className="col-12">
          <div className="row mx-auto">
            <div
              className={`col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right justify-content-between ${
                isContinue ? '' : 'd-flex'
              }`}
            >
              <Link
                className={`btn ${isContinue ? 'btn-theme-submit' : 'btn-outline-primary'} btn-md`}
                to={`/on-boarding/${version}/v/${projectId}/summary`}
                title={isContinue ? 'Continue to Next Step' : 'Skip to Next Step'}
              >
                <i
                  className={`wb  ${
                    isContinue ? 'webconnect-chevron-double-right' : 'webconnect-skip-forward-fill'
                  }`}
                ></i>
                &nbsp;{isContinue ? 'Continue to next step' : 'Skip to next step'}
              </Link>
            </div>
          </div>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    onBoarding: state.onBoarding,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GoogleFonts);
